import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import useToast from 'hooks/useToast';

export default function RedirectWithToast({ to, message, type }) {
  const { addToast } = useToast();
  addToast({
    type,
    message,
  });
  return <Redirect to={to} />;
}

RedirectWithToast.displayName = 'RedirectWithToast';
RedirectWithToast.propTypes = {
  to: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  type: PropTypes.string,
};
RedirectWithToast.defaultProps = {
  type: 'success',
};
